export default __webpack_public_path__ + "static/media/acorn-100.84b4a1bf.png";